import type { ActionInput } from "../ActionInput.js";
import {
  hasArrivedAtLatestPlaceOfSafety,
  hasPlaceOfSafety,
  hasTriageForm,
  incidentIsActive,
  userIsIncidentOwner,
} from "../helpers.js";

type MarkArrivalAction = {
  canMarkArrival: boolean;
  hasArrivedAtLatestPlaceOfSafety: boolean;
};

function allArrivalConditionsMet(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    hasPlaceOfSafety(actionInput)
  );
}

function canMarkArrival(actionInput: ActionInput): boolean {
  return (
    allArrivalConditionsMet(actionInput) &&
    !hasArrivedAtLatestPlaceOfSafety(actionInput)
  );
}

function hasMarkedArrival(actionInput: ActionInput): boolean {
  return (
    allArrivalConditionsMet(actionInput) &&
    hasArrivedAtLatestPlaceOfSafety(actionInput)
  );
}

export function calculateArrivalActions(
  actionInput: ActionInput,
): MarkArrivalAction {
  return {
    canMarkArrival: canMarkArrival(actionInput),
    hasArrivedAtLatestPlaceOfSafety: hasMarkedArrival(actionInput),
  };
}
